import { render, staticRenderFns } from "./_base-comment.vue?vue&type=template&id=1beb53ad"
import script from "./_base-comment.vue?vue&type=script&lang=js"
export * from "./_base-comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports